<template lang="pug">
Container(@loaded="afterload" :itemId="fileId")
    a-spin.office-view(v-if="!previewContent") 正在加载中...
    vue-office-excel(v-else :src="previewContent" 
        style="height: calc(100vh - 0px);" 
        :options="options")
</template>

<script>
import Container from './Container.vue';
import VueOfficeExcel from '@vue-office/excel';
import '@vue-office/excel/lib/index.css';
import _ from 'lodash';
import axios from 'axios';
const host = '/api/fs';


export default {
    props: ['fileId'],
    data() {
        
        return {
            previewContent: null,

            id: '',
            name: '',
        }
    },
    
    methods: {
        afterload(info) {
            this.id = info.id;
            this.name = info.name;
            

            this.load();
        },
        load() {
            axios.get(`${host}/download/${this.id}`, {
                headers: {
                    'x-jwt': this.$api.jwt,
                },
                responseType: 'blob',
            }).then(res => {
                let fileReader = new FileReader();
                fileReader.readAsArrayBuffer(res.data);
                fileReader.onload = (e) => {
                    this.previewContent = e.target.result;
                };
            })
        }
    },
    computed: {
        options() {
            
            return {
                xls: _.endsWith(this.name, '.xls'),
                widthOffset: 10,
                heightOffset: 10,
            }
        }
    },
    components: {
        Container,
        VueOfficeExcel
    }
}
</script>

<style lang="less" scoped>

</style>
